<script context="module">
	import { z } from "zod";
	export const name = "opening";

	export const CustomFields = z.object({
		button_text: z.string().default("Breaking"),
		background: z
			.enum([
				"inherit-page",
				"inherit-content-category",
				"static",
				"none",
			])
			.default("static"),
	});
</script>

<script lang="ts">
	import Data from "@reperio-news/core.components/blocks/ContentItem/Data";
	type Data = z.infer<typeof Data>;
	import ImageView from "@reperio-news/core.components/ImageView.svelte";
	import { slugToColor } from "../TopMenu/View.svelte";
	import { getContext } from "svelte";
	import { stripTags } from "@reperio-news/core.components/includes/Helpers";
	import { getURLRel } from "../../includes/helpers.svelte";
	export let data: Data;

	const context: SvelteStore<any> = getContext("context");

	let contextColor = "#000";
	// let categoryColor = "#000";
	let withBackground = "#111";

	const c = getContext("parentBlockColumnCount");

	$: if (
		data &&
		data.content &&
		data.content.url &&
		$context &&
		$context.global_blocks &&
		$context.global_blocks.TopMenu_main_menu
	) {
		/*
		categoryColor = slugToColor(
			data.content.url,
			$context.global_blocks.TopMenu_main_menu.data?.items
		);
		*/

		switch (data.custom_fields?.background || "inherit-page") {
			case "static":
				contextColor = "rgba(1, 1, 1, 1)";
				break;

			case "inherit-page":
				contextColor = slugToColor(
					$context.path,
					$context.global_blocks.TopMenu_main_menu.data?.items,
					"rgba"
				);
				break;
			case "inherit-content-category":
				contextColor = slugToColor(
					data.content.category?.slug,
					$context.global_blocks.TopMenu_main_menu.data?.items,
					"rgba"
				);
				break;
			case "none":
				withBackground = null;
				break;
		}
	}

	function init(el: HTMLElement) {
		(el.parentNode as HTMLElement).style.flexBasis = "auto";
	}
</script>

<div
	class="container co-{$c}"
	style="{withBackground
		? `background: ${withBackground};`
		: ''}{withBackground && contextColor
		? `background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.9) 35%, ${contextColor} 100%);`
		: ''}"
	use:init
>
	<div class="subcontainer">
		<a
			class="main"
			href={data.content.url}
			rel={getURLRel(data.content.url)}
			title={stripTags(data.content.summary)}
			><span>{data.content.title}</span></a
		>
		{#if data && data.content}
			{#if data.content.poster}
				<ImageView
					src={data.content.poster}
					width={1400}
					height={650}
					contrast={1.25}
					quality={95}
					animatedQuality={45}
					asBackground={false}
					fit="cover"
					widths={[1400, 1000, 600, 450]}
					heights={[650, 465, 280, 210]}
					crop={data.content.poster.crop}
				/>

				<div class="info">
					{#if data.custom_fields && data.custom_fields.button_text && data.custom_fields.button_text.trim() !== ""}
						<div class="button">
							{data.custom_fields.button_text}
						</div>
					{/if}

					<div class="title">{@html stripTags(data.content.title, ["i", "b", "strong", "font"])}</div>
					<div class="summary">{@html stripTags(data.content.summary, ["i", "b", "strong", "font"])}</div>
				</div>
			{/if}
		{/if}
	</div>
</div>

<style lang="scss">
	.container {
		width: 100%;
		height: auto;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;

		.subcontainer {
			display: block;
			color: inherit;
			position: relative;
			width: 100%;
			max-width: 1400px;
			/* box ratio matches the 1400x650 request — scales down
			   proportionally instead of letterboxing below 1400px */
			aspect-ratio: 1400 / 650;
			height: auto;
			max-height: 650px;
			padding: 0px;
			background-color: #111;
			margin-bottom: 10px;
			min-width: 300px;
			overflow: hidden;

			a.main {
				position: absolute;
				left: 0px;
				top: 0px;
				width: 100%;
				height: 100%;
				z-index: 1;
				span {
					visibility: hidden;
				}
			}

			:global(img) {
				mask-image: linear-gradient(
					to bottom,
					rgba(0, 0, 0, 1),
					rgba(0, 0, 0, 0)
				);
				-webkit-mask-image: -webkit-gradient(
					linear,
					left top,
					left bottom,
					from(rgba(0, 0, 0, 1)),
					to(rgba(0, 0, 0, 0))
				);
			}

			.info {
				padding-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				position: absolute;
				flex-direction: column;
				left: 0px;
				bottom: 0px;
				width: 100%;
				// height: 300px;
				background: rgb(0, 0, 0);
				background: linear-gradient(
					180deg,
					rgba(0, 0, 0, 0.01) 0%,
					rgba(0, 0, 0, 0.5) 60%,
					rgba(0, 0, 0, 1) 100%
				);

				.button {
					margin-top: -25px;
					background-color: red;
					padding: 5px;
					font-family: "PT Sans Narrow", sans-serif;
					font-weight: bold;
					font-size: 1.25em;
					text-transform: uppercase;
					color: #fff;
					letter-spacing: 1px;
					background-color: red;
					margin-bottom: 10px;
				}

				.summary {
					font-size: 0.85em;
					color: #eee;
					font-family: "Oswald", sans-serif;
					font-size: 2rem;
					letter-spacing: 1px;
					width: 85%;
					font-weight: 500;
					margin: auto;
					text-align: center;
				}

				.title {
					text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.4);
					font-family: "Oswald", sans-serif;
					font-style: normal;
					font-weight: 700;
					text-transform: uppercase;
					color: #fff;
					margin-top: auto;
					font-size: 5rem;
					letter-spacing: 1px;
					text-align: center;
				}
			}
		}
	}

	:global {
		.carousel-news {
			div.container {
				width: calc((var(--parent-width))) !important;
				min-width: calc((var(--parent-width))) !important;
			}
		}
	}

	@media only screen and (max-width: 1200px) {
		.container {
			.subcontainer {
				.info {
					.title {
						font-size: 2.35rem;
					}

					.summary {
						font-size: 1.6rem;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 750px) {
		.container {
			margin-bottom: 5px;
			height: auto;
			max-height: 470px;

			:global {
				picture,
				img {
					object-fit: contain !important;
					width: 100%;
					height: auto;
					object-position: center;
				}
			}

			.subcontainer {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				height: auto !important;
				/* text stacks below the image here — the desktop
				   aspect-ratio box would clip it */
				aspect-ratio: auto;
				max-height: none;

				.info {
					position: relative;

					.title {
						font-size: 2rem;
						margin-bottom: 10px;
					}

					.summary {
						font-size: 1.25rem;
					}
				}
			}
		}
	}
</style>
